import { WSPosterProps } from "@wingspanhq/fe-component-library";
import {
  BackgroundCheckStatus,
  BiometricIdentityVerificationRequestStatus,
  PayeeRequirement,
  SharedFileRequestStatus,
  SignatureRequestStatus
} from "@wingspanhq/wingspan-api-sdk";
import React from "react";

import { RequirementCardContent } from "../components/RequirementCardContent";
import { selectorIsRequirementApproved } from "../selectors/selectorIsRequirementApproved";
import { selectorIsRequirementPendingApproval } from "../selectors/selectorIsRequirementPendingApproval";
import { selectorIsRequirementRejected } from "../selectors/selectorIsRequirementRejected";

export const mapStatusesToCardDetails = <
  Status extends
    | SignatureRequestStatus
    | SharedFileRequestStatus
    | BackgroundCheckStatus
    | BiometricIdentityVerificationRequestStatus
>(props: {
  requirement: PayeeRequirement;
  documentStatus: Status;
  documentStatuses: Record<Status, WSPosterProps>;
  pendingApprovalStatus: Status extends
    | SignatureRequestStatus
    | SharedFileRequestStatus
    | BiometricIdentityVerificationRequestStatus
    ? WSPosterProps
    : null;
  rejectedStatus: Status extends
    | SignatureRequestStatus
    | SharedFileRequestStatus
    | BiometricIdentityVerificationRequestStatus
    ? WSPosterProps
    : null;
  approvedStatus: Status extends BiometricIdentityVerificationRequestStatus
    ? WSPosterProps
    : null;
  customContent?: React.ReactNode | null;
}): React.ReactNode => {
  const {
    requirement,
    documentStatus,
    pendingApprovalStatus,
    rejectedStatus,
    approvedStatus,
    documentStatuses,
    customContent
  } = props;

  if (customContent) {
    return customContent;
  }

  let posterProps: WSPosterProps | null;

  if (
    selectorIsRequirementPendingApproval(requirement) &&
    pendingApprovalStatus
  ) {
    posterProps = pendingApprovalStatus;
  } else if (selectorIsRequirementRejected(requirement) && rejectedStatus) {
    posterProps = rejectedStatus;
  } else if (selectorIsRequirementApproved(requirement) && approvedStatus) {
    posterProps = approvedStatus;
  } else {
    posterProps = documentStatuses[documentStatus];
  }

  if (!posterProps) {
    return null;
  }

  return (
    <RequirementCardContent
      description={posterProps.description}
      title={posterProps.title}
      type={posterProps.type}
    />
  );
};
